{
  "adminTime": {
    "showUtc": "顯示 UTC 時間",
    "showLocal": "顯示本地時間"
  },
  "brand": "SHEN NONG SHI",
  "product": "作業工作區",
  "title": "SHEN NONG SHI",
  "pageTitle": "{{page}} · SHEN NONG SHI",
  "language": "語言",
  "lang": {
    "en": "English",
    "zh-TW": "繁體中文"
  },
  "theme": {
    "label": "主題",
    "system": "跟隨系統",
    "light": "淺色",
    "dark": "深色"
  },
  "footer": {
    "hrThread": "有問題？請透過您既有的 HR 信件往來聯繫。",
    "utc": "UTC"
  },
  "actions": {
    "continue": "繼續",
    "cancel": "取消",
    "confirm": "確認",
    "close": "關閉",
    "copy": "複製",
    "copied": "已複製",
    "reveal": "顯示",
    "hide": "隱藏",
    "retry": "再試一次",
    "back": "返回",
    "save": "儲存",
    "delete": "刪除",
    "openInNewTab": "在新分頁開啟",
    "skipToContent": "跳至主要內容"
  },
  "time": {
    "hours": "{{count}} 小時",
    "minutes": "{{count}} 分鐘",
    "daysHoursLeft": "剩餘 {{days}} 天 {{hours}} 小時",
    "hoursMinutesLeft": "剩餘 {{hours}} 小時 {{minutes}} 分",
    "left": "剩餘",
    "localAndUtc": "{{local}}（{{utc}}）",
    "about": "約 {{min}}–{{max}} 分鐘"
  },
  "state": {
    "provisioning": "建立中",
    "warming": "預熱中",
    "ready": "可以啟動",
    "starting": "GPU 啟動中",
    "booting": "工作區啟動中",
    "running": "執行中",
    "stopping": "暫停中",
    "paused": "已暫停",
    "error": "發生錯誤",
    "ended": "已結束",
    "deleted": "已刪除"
  },
  "errors": {
    "generic": "發生錯誤，我們已收到通知。",
    "network": "網路錯誤，請檢查連線後再試。",
    "rate_limited": "嘗試次數過多，請稍候再試。",
    "unauthorized": "您的登入已失效，請重新開啟邀請連結。",
    "forbidden": "您沒有此權限。",
    "action_in_progress": "上一個動作仍在進行中，請稍候。",
    "invalid_state": "目前無法執行此動作。",
    "not_found": "找不到內容。"
  },
  "a11y": {
    "loading": "載入中",
    "statusUpdated": "狀態更新：{{state}}",
    "menu": "選單"
  },
  "workspace": {
    "manualOperatorHint": "此既有工作區須使用受保護的管理員安裝工具，完成後再驗證並啟用安全存取。",
    "notConfigured": "安全工作區設定不完整。管理員須先完成閘道與 Cloudflare 憑證設定，才能繼續。",
    "setupDisabled": "安全工作區設定尚未啟用。請先在設定中啟用自動安全存取，再重試。",
    "existingOperatorHint": "此既有工作區尚未轉換。管理員可選擇啟用，並完成受保護的安裝流程。",
    "opening": "正在開啟工作區…",
    "popupBlocked": "請允許 作業平台 開啟彈出式視窗後重試。",
    "openFailed": "無法開啟工作區。請重試；若問題持續，請聯絡管理員。",
    "status": "工作區存取：{{status}}",
    "unavailable": "工作區存取需要處理，請聯絡 HR 或管理員。",
    "vscode": "開啟 VS Code",
    "viewer": "開啟 Viewer",
    "tools": {
      "vscode": "VS Code",
      "viewer": "Viewer",
      "opencode": "OpenCode"
    },
    "copyUrl": "複製 {{tool}} 網址",
    "linkHint": "這些網址會保持不變。請透過 作業平台 登入，即可免密碼開啟。",
    "pausedHint": "工作區未執行時無法開啟應用程式。請在 作業平台 查看狀態，若可繼續則先恢復工作區。",
    "removedHint": "安全工作區存取已移除。如需再次存取，請聯絡管理員。",
    "removingHint": "正在移除安全工作區存取，既有連線已關閉。",
    "preparing": "正在準備安全存取。準備完成且工作區執行中時即可開啟。",
    "manage": "安全工作區存取",
    "provision": "為此既有工作區設定安全存取",
    "retryProvision": "重試設定",
    "activate": "驗證並啟用",
    "cleanup": "移除安全存取",
    "cleanupConfirm": "這會關閉工作區連線，並移除 HTTPS 網址與通道。原本的主機名稱不會再次使用。",
    "operatorHint": "新建工作區會自動準備安全存取。設定完成且工作區啟動後，即可開啟應用程式。",
    "operationFailed": "設定未完成。請查看工作區狀態後重試，或聯絡負責工作區設定的管理員。",
    "states": {
      "pending": "等待中",
      "tunnel": "正在建立通道",
      "origin-protected": "來源已受保護",
      "connector": "正在安裝安全存取",
      "verified": "正在驗證 HTTPS",
      "active": "已就緒",
      "deleting": "正在移除存取",
      "deleted": "存取已移除",
      "error": "需要處理"
    },
    "startingApps": "應用程式啟動中",
    "startingAppsHint": "安全連結已設定，應用程式仍在啟動。機器就緒後，兩個按鈕即可使用。",
    "stoppingApps": "停止中",
    "stoppingAppsHint": "機器正在停止。請等到暫停完成後再繼續。",
    "closedApps": "已關閉",
    "closedAppsHint": "此工作區已關閉，無法開啟應用程式。",
    "failedApps": "無法使用",
    "failedAppsHint": "機器需要處理。請先排除啟動錯誤或重試，再開啟應用程式。",
    "pausedApps": "已暫停",
    "pausedAppsHint": "工作區未執行時無法開啟應用程式。請在作業平台查看狀態，若可繼續則先恢復工作區。",
    "notLaunchedApps": "尚未啟動",
    "notLaunchedAppsHint": "準備好後請啟動作業。啟動完成後即可使用應用程式。",
    "preparingApps": "準備中",
    "preparingAppsHint": "作業機器正在準備，目前尚無法使用應用程式。",
    "unavailableApps": "無法使用",
    "unavailableAppsHint": "目前工作區狀態無法開啟應用程式。",
    "signInRequired": "登入已過期。請重新登入，再開啟工作區。",
    "consentRequired": "請先在平台閱讀並同意目前的隱私權同意書，再開啟工作區。",
    "rateLimited": "開啟工作區的次數過多。請等候一分鐘後重試。",
    "accessDenied": "工作區存取遭拒。請重新整理平台，確認登入與機器狀態後再試。",
    "gatewayUnavailable": "安全工作區存取尚未就緒。請等待設定完成後再試。",
    "vscodeNotReady": "VS Code 尚未回應，請稍候再嘗試開啟。",
    "viewerNotReady": "檢視器尚未就緒，請稍候再嘗試開啟。你仍可嘗試開啟 VS Code。",
    "opencode": "開啟 OpenCode",
    "opencodeNotReady": "OpenCode 尚未就緒。請稍候再試，仍可使用 VS Code。"
  },
  "guide": {
    "title": "設計指南",
    "eyebrow": "SHEN NONG SHI / 產品設計",
    "intro": "專注於工作的空間。清楚的文字、簡潔的介面，用適量色彩標示重要資訊。",
    "source": "公司品牌識別規範 ↗",
    "scope": "品牌、色彩與字體依公司識別規範；以下版面與互動規則為 本平台的產品應用。",
    "identity": "品牌識別",
    "identityBody": "使用公司原始圖檔，維持比例與標誌留白。於頁首呈現一次，以神農氏作為網站識別。",
    "identityRule": "深色背景使用原始反白圖檔。不可變色、拉伸、降低透明度或以字體重製標誌。各組合的最小尺寸與留白依規範 §1.3–1.3.5。",
    "lockup": "產品頁首",
    "mark": "公司標誌",
    "color": "色彩與對比",
    "colorBody": "介面以銀、黑、白為主。藍色用於主要操作與連結，紅色表示危險，琥珀色為產品警示色。",
    "silver": "品牌銀灰",
    "silver2": "輔助銀灰",
    "blue": "操作藍",
    "red": "危險紅",
    "tokens": "隨主題調整的介面色彩",
    "colorRule": "品牌色票在明暗模式中固定不變，語意色彩則隨主題調整以保持易讀。銀灰色僅供裝飾，不用於白底內文。一般狀態維持中性色，並附文字標籤。",
    "type": "文字排版",
    "typeBody": "英文使用 Roboto，繁體中文使用 Noto Sans TC。每頁一個清楚的主標題，搭配段落標題與易讀的輔助文字。",
    "typeTitle": "您的工作區",
    "typeSection": "準備就緒，隨時開始",
    "typeBodySample": "開啟工作區繼續作業。離開時請暫停機器。",
    "typeCaption": "GPU 時間僅在 Isaac Sim 就緒時扣除。",
    "typeRule": "主標題 28 / 36 px・段落 20–24 px・內文 14–16 px・輔助文字 12 px。時間與費用使用等寬數字，程式碼與憑證才使用等寬字體。",
    "layout": "版面與間距",
    "layoutBody": "以對齊與留白組織相關內容。段落間使用分隔線，只有需要明確邊界的內容才使用外框。",
    "layoutRule": "以 4 px 為間距基準・群組內 16–24 px・段落間 40–48 px・控制項圓角 4 px。窄螢幕採單欄，操作按鈕易於觸及。陰影僅用於浮層。",
    "actions": "操作與表單",
    "actionsBody": "VS Code 與 Viewer 都是作業工具，使用相同的藍色按鈕。暫停是主要機器控制。破壞性操作需分開呈現並清楚說明。",
    "primary": "開啟 VS Code",
    "secondary": "開啟 Viewer",
    "dangerAction": "結束工作階段",
    "email": "登入電子郵件",
    "emailHelp": "登入驗證碼將寄送至此地址。",
    "errorLabel": "作業名稱",
    "error": "請輸入作業名稱。",
    "disabled": "尚無法使用",
    "loading": "正在開啟工作區",
    "states": "狀態與回饋",
    "statesBody": "說明目前情況與下一步。即使沒有色彩，文字仍能傳達完整意義。僅在操作進行時使用動畫。",
    "info": "機器已就緒，請開啟 VS Code 繼續。",
    "warning": "GPU 剩餘時間不足 1 小時。請在時間用盡前儲存工作。",
    "danger": "時間已用盡。機器將於 09:41 後關閉，請立即保存工作副本。",
    "dialogTitle": "確定結束工作階段？",
    "dialogBody": "結束後將無法繼續此工作階段。請先保存工作副本。",
    "dialogTrigger": "預覽確認視窗",
    "toastTrigger": "預覽通知",
    "toastTitle": "通知預覽",
    "toastBody": "您的變更已儲存。",
    "accessibility": "保留清楚的鍵盤焦點、控制項標籤、關聯的錯誤訊息及減少動態效果支援。明暗主題與兩種語言皆需檢查。",
    "examples": "開啟畫面範例",
    "candidatePreview": "候選人工作區 ↗",
    "adminPreview": "管理後台 ↗",
    "pause": "暫停機器",
    "workspace": "工作區生命週期",
    "workspaceBody": "只有 Isaac Sim 就緒且候選人可使用時，才顯示整個存取區塊；無法使用時隱藏。點選下方狀態可查看實際畫面。",
    "workspaceTiming": "GPU 額度僅在 Isaac Sim 就緒時扣除。首次啟動後，作業期限會持續計算，包含啟動與暫停期間。",
    "workspaceAdmin": "管理員保留連線資訊以便排查問題。安全網址已設定，不代表應用程式已就緒。",
    "lifecycle": {
      "preparation": {
        "title": "初次準備",
        "body": "系統自動準備。候選人首次啟動前，不顯示暫停、結束或存取區塊。"
      },
      "startup": {
        "title": "開機／啟動中",
        "body": "首次啟動後，暫停會取消本次啟動並保留檔案；結束會永久結束作業。存取區塊保持隱藏。"
      },
      "running": {
        "title": "可開始作業",
        "body": "顯示存取區塊，VS Code 與 Viewer 使用相同的藍色按鈕。暫停為主要機器控制，結束獨立呈現。"
      },
      "paused": {
        "title": "已暫停／停止中",
        "body": "隱藏存取區塊。停止中等待確認；暫停後提供繼續與結束。"
      },
      "grace": {
        "title": "儲存寬限期",
        "body": "顯示關機倒數，僅提供結束。應用程式仍可使用且存取尚未到期時，保留存取區塊。"
      },
      "ended": {
        "title": "已結束／已到期",
        "body": "隱藏存取與機器操作。保留完成訊息、使用資訊與活動紀錄。"
      }
    },
    "markdownTitle": "即時 Markdown 編輯器",
    "markdownHelp": "直接撰寫與套用格式，也可切換原始碼精確編輯 Markdown。題目、答案與 AI 訊息共用此編輯器。",
    "markdownSample": "## 清楚的思路\n\n先說明保證，再解釋**取捨**。\n\n- 確保可復原工作\n- 顯示目前進度"
  },
  "assignmentKind": {
    "isaac_sim": "Isaac Sim",
    "gpu_vscode": "GPU + VS Code",
    "free_response": "書面作答"
  },
  "markdownEditor": {
    "hint": "直接撰寫，Markdown 快捷語法會即時套用格式。",
    "sourceRequired": "此文件含有 HTML 或圖片，請編輯原始 Markdown 以保留完整內容。",
    "source": "Markdown 原始碼",
    "formatted": "格式化編輯器",
    "loading": "載入編輯器中…",
    "formatting": "文字格式",
    "bold": "粗體",
    "italic": "斜體",
    "heading": "標題",
    "bullet": "項目清單",
    "ordered": "編號清單",
    "quote": "引用",
    "code": "程式碼區塊",
    "undo": "復原",
    "redo": "重做",
    "unavailable": "格式化編輯器無法載入，文字已保留，請繼續使用 Markdown 原始碼編輯。",
    "tooLong": "此欄位超過 {{limit}} 字元。請縮短後再提交，您的文字已保留。",
    "task": "待辦項目：{{text}}"
  }
}
